<template>
    <DCard
        padding
    >
        <BrandsForm
            ref="createForm"
            :errors="errors"
            :phone-country-code-placeholder="phoneCountryCodePlaceholder"
            :brand="brand"
            :brand-list="brandList"
            :all-payment-methods="allPaymentMethods"
            :available-languages="availableLanguages"
            :default-customer-language="defaultCustomerLanguage"
            :accounting-products="accountingProducts"
            :control-panels="controlPanels"
            :default-tenant-language="defaultTenantLanguage"
            @submit="storeBrand"
        />
    </DCard>
</template>

<script>
import BrandsForm from '~@/Components/Settings/Brands/Form'

export default {
    name: 'BrandCreate',
    components: {
        BrandsForm
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        phoneCountryCodePlaceholder: {
            type: String,
            default: '+49'
        },
        brand: {
            type: Object,
            default () {
                return {}
            }
        },
        brandList: {
            type: Array,
            default () {
                return []
            }
        },
        allPaymentMethods: {
            type: Array,
            default () {
                return []
            }
        },
        availableLanguages: {
            type: Array,
            default: () => { return [] }
        },
        defaultCustomerLanguage: {
            type: String,
            default: null
        },
        accountingProducts: {
            type: Array,
            default: () => { return [] }
        },
        controlPanels: {
            type: Array,
            default: () => { return [] }
        },
        defaultTenantLanguage: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        storeBrand (form) {
            form.post(this.$route('settings.brands.store'))
        }
    }
}
</script>
